<template>
  <k-dialog>
    <div class="dialog-wrapper dialog-readtip-wrapper">
      <a
        class="dialog-btn-close"
        @click="$store.commit('CLOSE_DIALOG', 'ReadTip')"
      ></a>
      <div class="title"></div>
      <div class="task-desc">
        <div class="task-title">任务详情</div>
        <p class="desc">
          请您仔细阅读游戏介绍页面，完成后即可 获得<span
            >{{ prizeNum || 0 }}次</span
          >抽奖机会，即有机会获得以下奖励
        </p>
        <div class="task-status-box flex">
          <div class="status-txt">任务完成状态</div>
          <div
            class="task-status"
            :class="{
              'task-status--unfinish': !isFinished,
              'task-status--complete': isFinished
            }"
          ></div>
        </div>
      </div>
      <div class="prize-show">
        <div class="show-title"><span>奖品展示</span></div>
        <img class="prize-list" :src="img" />
      </div>

      <button v-if="isFinished" class="dialog-btn-submit" @click="onSubmit">
        开始抽奖
      </button>
    </div>
  </k-dialog>
</template>
<script>
import KDialog from '@com/base/Dialog';
export default {
  name: 'ReadTip',
  props: {
    img: {
      type: String,
      default: () => ''
    },
    isFinished: {
      type: Boolean,
      default: () => false
    },
    prizeNum: {
      type: Number,
      default: () => null
    }
  },
  components: {
    KDialog
  },
  methods: {
    onSubmit() {
      this.$emit('start-turns');
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-readtip-wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 501;
  .title {
    width: 268px;
    height: 46px;
    margin: 0 auto;
    background: url('@/assets/imgs/read/read-title.png') no-repeat center/100%
      100%;
  }

  .task-desc {
    padding: 27px 20px;
    .task-title {
      color: #333;
      font-size: 26px;
    }
    p {
      color: #666;
      font-size: 24px;
      margin-top: 20px;
      line-height: 35px;
      span {
        color: #ffc341;
        font-weight: bold;
      }
    }
    .task-status-box {
      border-top: 1px solid #d9d9d9;
      justify-content: space-between;
      padding-top: 28px;
      margin-top: 28px;
      .status-txt {
        color: #ffc341;
        font-size: 24px;
        font-weight: bold;
      }
    }
    border: 1px solid #d9d9d9;
    border-radius: 20px;
    margin: 44px auto 0;
    .task-status {
      width: 110px;
      height: 28px;
    }
    .task-status--complete {
      background: url('@/assets/imgs/read/task-status--complete.png') no-repeat
        center/100% 100%;
    }
    .task-status--unfinish {
      background: url('@/assets/imgs/read/task-status--unfinish.png') no-repeat
        center/100% 100%;
    }
  }
}
.prize-show {
  margin: 44px auto 0;
  .show-title {
    position: relative;
    border-top: 1px solid #666;
    width: 300px;
    height: 30px;
    margin: 0 auto 20px;
    span {
      position: absolute;
      width: 150px;
      top: -12px;
      left: 50%;
      display: block;
      background: #fff;
      color: #666;
      font-size: 24px;
      text-align: center;
      transform: translateX(-50%);
    }
  }
  .prize-list {
    display: block;
    width: 100%;
  }
}
</style>
